import React from 'react'
import ReactMarkdown from "react-markdown";

import './markdown-styles.module.css';

function LinkRenderer(props) {
    
    return (
      <a href={props.href} target="_blank" rel="noreferrer">
        {props.children}
      </a>
    );
  }

const MarkdownRenderer = ({ children }) => {
  return (
    <ReactMarkdown className="txt-view viewContentTxt" components={{ a: LinkRenderer }}>{children}</ReactMarkdown>
  )
}

export default MarkdownRenderer